if (!customElements.get('featured-collection-tabs')) {
  class FeaturedCollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const sectionId = this.getAttribute('data-section');
      const buttons = document.querySelectorAll(`.featured-tab-button[data-section="${sectionId}"]`);
      
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleTabClick(button, buttons);
        });
      });
    }

    handleTabClick(clickedButton, allButtons) {
      const targetTab = clickedButton.getAttribute('data-tab');
      
      if (clickedButton.getAttribute('aria-current') === 'true') return;

      allButtons.forEach(btn => {
        btn.setAttribute('aria-current', 'false');
      });
      clickedButton.setAttribute('aria-current', 'true');

      const allTabs = this.querySelectorAll('[tab-item]');
      
      allTabs.forEach(tab => {
        const tabId = tab.getAttribute('data-tab');
        
        if (tabId === targetTab) {
          tab.setAttribute('tab-selected', '');
        } else {
          tab.removeAttribute('tab-selected');
        }
      });
    }
  }

  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
}
